export default __webpack_public_path__ + "static/media/1F48DCEA-F6BC-4545-BA9C-45D6E0BF5A69_1_105_c.24d2d150.jpeg";